import React from 'react'
import PropTypes from 'prop-types'
import Slick from 'react-slick'

class CategoriesSlider extends React.Component {
  constructor(props) {
    super(props)

    this.slickSettings = {
      dots: false,
      prevArrow: (
        <button>
          <i className="icon icon-angle-left" />
        </button>
      ),
      nextArrow: (
        <button>
          <i className="icon icon-angle-right" />
        </button>
      ),
      infinite: false,
      slidesToShow: 4,
      arrows: true,
      autoplay: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    }
  }

  renderedCategories() {
    const { categories } = this.props

    return categories.map((category) => {
      const { thumbnailUrl, title, id, url } = category

      return (
        <a
          href={url}
          key={id}
          className="map-explorer__header__slider__category"
        >
          <div className="map-explorer__header__slider__category__container">
            <img
              className="map-explorer__header__slider__category__image"
              src={thumbnailUrl}
              alt={title}
            />
          </div>
          <h4 className="map-explorer__header__slider__category__title">
            {title}
          </h4>
        </a>
      )
    })
  }

  render() {
    const { categories } = this.props

    if (!categories) {
      return null
    }

    return (
      <div className="map-explorer__header__slider">
        <Slick {...this.slickSettings}>{this.renderedCategories()}</Slick>
      </div>
    )
  }
}

CategoriesSlider.defaultProps = {
  categories: [],
}

CategoriesSlider.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      thumbnailUrl: PropTypes.string.isRequired,
    })
  ),
}

export default CategoriesSlider
